(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kd-collection-seo"]) return;
  try {
    
  class KdSeoText extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('.kd-seo-text__body');
      const toggle = this.querySelector('.kd-seo-text__toggle');
      const limit = Number(this.dataset.collapsedHeight) || 0;
      // A text only a little taller than the limit is left open: a button that
      // reveals two more lines costs more than it saves.
      if (!body || !toggle || !limit || body.scrollHeight <= limit + 80) return;

      this.style.setProperty('--kd-seo-collapsed', limit + 'px');
      this.classList.add('is-collapsible');
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const open = this.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
  if (!customElements.get('kd-seo-text')) customElements.define('kd-seo-text', KdSeoText);

  } catch(e) { console.error(e); }
})();
})();
